export default __webpack_public_path__ + "static/media/Easy-Returns-Refund.fcbfe222.png";